//libs
import { DialogTitle } from "@headlessui/react";
//components
import Button from "components/Button";
import ModalDialog from "components/ModalDialog";

export default function NDAConfirmationModal({
  ndaDocument,
  open,
  setOpen,
  onProceed,
}) {
  const handleProceed = () => {
    setOpen(false);
    onProceed();
  };

  return (
    <ModalDialog open={open} setOpen={setOpen} size="lg">
      <div className="space-y-4">
        <DialogTitle
          as="h3"
          className="text-base font-semibold leading-6 text-gray-900"
        >
          Accept NDA And Participate
        </DialogTitle>
        <object
          data={ndaDocument}
          type="application/pdf"
          width="100%"
          height="400px"
        >
          <p>
            Alternative text - include a link{" "}
            <a href={ndaDocument}>
              to the PDF!
            </a>
          </p>
        </object>
        {/* <div className="relative flex gap-x-3">
          <div className="flex h-6 items-center">
            <input
              id="nda"
              name="nda"
              type="checkbox"
              value={isNDAAccepted}
              onChange={(e) => setIsNDAAccepted(e.target.value)}
              className="h-4 w-4 rounded border-gray-300 text-purple-600 focus:ring-purple-600"
            />
          </div>
          <div className="text-sm leading-6">
            <label className="font-medium text-gray-900" htmlFor="nda">
              <span>Accept</span>
              <a
                href={ndaDocument || "http://google.com"}
                target="blank"
                className="underline text-purple-600 px-2"
              >
                NDA
              </a>
              terms and conditions
            </label>
          </div>
        </div> */}
        <div className="sm:flex gap-3 w-full">
          <Button type="button" onClick={handleProceed}>
            Accept NDA and Participate
          </Button>
          <button
            type="button"
            data-autofocus
            onClick={() => setOpen(false)}
            className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
          >
            Not Accept
          </button>
        </div>
      </div>
    </ModalDialog>
  );
}
